import React from 'react';
import {OpenedLayerResult} from '../utils/use-layer';
import {useSafeContext} from '../utils/use-safe-context';

type LayerContextValue = OpenedLayerResult | undefined;

export const LayerContext = React.createContext<LayerContextValue>(undefined);

export function useLayerContext(): LayerContextValue {
  return React.useContext(LayerContext);
}

/** Only to be used when we are sure we're inside a layer */
export function useSafeLayerContext(): OpenedLayerResult {
  return useSafeContext(LayerContext, 'Layer');
}
